AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Models", "Master");

AoPS.Ebooks.Models.Master = (function () {
	// Dependencies
	var LoadUtils = AoPS.LoadUtils;
	var EbkMBase = AoPS.Ebooks.Models.Base;
	var EbkModels = AoPS.Ebooks.Models; // .Book

	return EbkMBase.BaseModel.extend({
		defaults: {
			user_id: -1,
			is_admin: false,
			is_offline: false,
			is_embedded: false,
			sku_table: null, // object loaded from server, format is store_sku : book_id
		},
		/** Additional attributes:
			books: collection of Book models
		*/

		initialize: function () {
			this.set("books", new EbkMBase.BaseCollection());
			this.get("books").setCreateFunction(
				_.bind(function (id) {
					return new EbkModels.Book({id: id, master: this});
				}, this)
			);

			this.setLoader(
				new LoadUtils.LoadManager({
					loadHandler: this.loadBookList,
					context: this,
				})
			);
		},

		getAccessibleBooks: function () {
			return new Backbone.Collection(
				this.get("books").filter(function (book) {
					return book.get("has_access");
				})
			);
		},

		getBookIdFromSku: function (sku) {
			var table = this.get("sku_table");
			var book_id = table && table[sku];
			return book_id || 0;
		},

		loadBookList: function (callback) {
			EbkMBase.ajax.run(
				"load_user_book_list",
				{
					user_id: this.get("user_id"),
				},
				_.bind(function (ok, data) {
					if (!ok) {
						return callback(ok, data);
					}
					this.unpack(data.response);
					callback(ok, {});
				}, this)
			);
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			this.setFields(data);

			this.get("books").unpackAll(data.books, "book_id");

			this.markAsLoaded(true);
		},
	});
})();
